import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const BoxUpArrowIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m17.117 4.358-1.159-1.4A1.21 1.21 0 0 0 15 2.5H5c-.392 0-.733.175-.967.458l-1.15 1.4A1.632 1.632 0 0 0 2.5 5.417v10.416c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V5.417c0-.4-.142-.775-.383-1.059ZM5.2 4.167h9.6l.692.833H4.517l.683-.833ZM4.167 15.833V6.667h11.666v9.166H4.167Zm2.5-4.166h2.125v2.5h2.416v-2.5h2.125L10 8.333l-3.333 3.334Z" />
  </Icon>
);

export default memo(BoxUpArrowIcon);
